import { t } from 'utilities/TranslationUtils';

/** "12 Kicks" / "1 Throw": count plus the right noun — throws for throw-ins, kicks for everything else. */
export function countTitle(isThrow: boolean, count: number): string {
  if (isThrow) return t(count === 1 ? 'measurementDetail.throwTitleOne' : 'measurementDetail.throwsTitle', { count });
  return t(count === 1 ? 'measurementDetail.kickTitleOne' : 'measurementDetail.kicksTitle', { count });
}
